import React, { useEffect, useState } from "react"
import { Container } from "react-bootstrap"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import Heading from "@/components/core/Heading/Heading"
import useViewport, { useViewportWidth } from "@/hooks/useViewport"
import SwatchItems from "@/components/PartsViewer/v2/SwatchItems"
import NotifyItems from "@/components/PartsViewer/v2/NotifyMe"
import LoadingPopupection from "@/components/PartsViewer/v2/DetailPopUp/Loading"
import ReplacementParts from "@/components/PartsViewer/v2/ReplacementParts"
import { shareaddToCart as addToCartHelper } from "@/components/sharedCart/shareCartHelper"
import { getProductInventory } from "@/services/productServices"
import { isImgUrlValid } from "@/services/ImageUrlValid"
import {
  CloseIcon,
  DownIcon,
  LoadingIcon,
  IncIcon,
  DecIcon,
  WarnIcon,
  CartCloseIcon,
  LoaderSpinner,
} from "@/components/PartsViewer/v2/icon.js"
import comingSoon from "@/public/scout_icon/coming-soon.jpg"
import { partsAddToCartEvent } from "@/components/PartsViewer/v2/analytics.js"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { isCanadaSite } from "@/utils/helper"

const DetailPopUp = props => {
  const {
    productId,
    setModal,
    partController,
    analytics,
    title,
    fullscreen,
    setWidthSize,
    selectedFile,
    siteName,
  } = props || {}

  const replaceId = selectedFile?.Parts?.filter(v => v?.Cod === productId)[0]
    ?.replaceRootSku
  const [loading, setLoading] = useState("loading")
  const [item, setItem] = useState({})
  const [variant, setVariant] = useState(null)
  const [variantList, setVariantList] = useState([])
  const [counter, setCounter] = useState(1)
  const [loaded, setLoaded] = useState(false)
  const [inventory, setInventory] = useState("")
  const [inventoryWarn, setInventoryWarn] = useState(false)
  const [cartToast, setCartToast] = useState(false)
  const [popupWidth, setPopupWidth] = useState(null)
  const [isValidImg, setIsValidImg] = useState(false)
  const [productNumber, setProductNumber] = useState({
    productId: null,
    replaceId: null,
  })
  const [showProduct, setShowProduct] = useState(true)
  const showStockDiscontinue = null
  const device = useViewport()
  const resizeWidth = useViewportWidth()
  const pdpDetails = useSelector(state => state.pdp)
  const { t } = useTranslation("common")
  const {
    addToCart,
    listPriceDescText,
    listPriceText,
    colorFinish,
    discontinuedText,
    outOfStockText,
    inventoryTextVal,
    replacesText,
  } = getTranslations(t)
  const kohlerCanadaFlag = isCanadaSite(siteName)
  useEffect(() => {
    const element = document.getElementsByClassName("product-list-viewer")[0]
    const headElement = document.querySelectorAll(
      ".modal-fullscreen.modal-container"
    )[0]
    if (element) {
      const { width } = element.getBoundingClientRect()
      const { height } = headElement.getBoundingClientRect()
      setWidthSize(width)
      setPopupWidth({ sidebarWidth: width, headHeight: height })
    }
  }, [resizeWidth])

  useEffect(() => {
    getItemDetails(productNumber?.productId)
  }, [productNumber])

  useEffect(() => {
    setProductNumber({ productId, replaceId })
  }, [productId])

  useEffect(() => {
    let timeId
    if (inventory && counter > inventory) {
      timeId = setTimeout(() => {
        setCounter(inventory)
      }, 1000)
      setInventoryWarn(true)
    }
    return () => clearTimeout(timeId)
  }, [counter])

  useEffect(() => {
    if (variant) {
      getVarientInfo()
    }
  }, [variant])

  const getVarientInfo = async () => {
    const currentVarent = variantList?.filter(val => val.id === variant)[0]
    if (currentVarent) {
      const isImgValid = await isImgUrlValid(item?.currentVarent?.imgUrl)
      setIsValidImg(isImgValid)
      setLoaded(true)
      const productQuantity = await getInventoryBySku(currentVarent?.id)
      setLoaded(false)
      setItem(prevState => {
        const details = prevState?.data?.varientDetails?.filter(
          val => val?.sku === currentVarent?.id
        )[0]
        return {
          ...prevState,
          currentVarent: { ...currentVarent, details },
        }
      })
      setInventory(productQuantity)
      setInventoryWarn(false)
      if (productQuantity && counter > productQuantity) {
        setCounter(productQuantity)
        setInventoryWarn(true)
      }
    }
  }

  const getItemDetails = async id => {
    const entry = partController.actions.get.entryByKey(id, selectedFile)
    setShowProduct(true)
    setLoading("loading")
    if (entry?.ctApiPromise) {
      const ctResponse = await entry.ctApiPromise
      if (ctResponse?.data) {
        setLoaded(true)
        const allSwatch = ctResponse?.data?.colorData
        const isImgValid = await isImgUrlValid(allSwatch?.[0]?.imgUrl)
        setIsValidImg(isImgValid)
        const currentSwatch = allSwatch?.[0]?.id
        const productQuantity = await getInventoryBySku(currentSwatch)
        const details = ctResponse?.data?.varientDetails?.filter(
          val => val?.sku === currentSwatch
        )[0]
        setLoaded(false)
        setInventory(productQuantity)
        setVariantList(allSwatch)
        setVariant(currentSwatch)
        setItem({
          ...ctResponse,
          currentVarent: { ...allSwatch[0], details },
        })
        setLoading("success")
      } else {
        setLoading("success")
        setShowProduct(false)
      }
    }
  }

  const incrementCounter = () => {
    setCounter(counter + 1)
  }

  const decrementCounter = () => {
    if (counter > 1) setCounter(counter - 1)
  }
  const handlerCounter = val => {
    const count = Number(val)
    if (count && count >= 1) {
      setCounter(count)
    }
  }

  const handlerCart = productInfo => {
    setLoaded(true)
    const data = [
      {
        sku: productInfo?.currentVarent?.id,
        quantity: counter,
        isBundleProduct: false,
        isBundle: false,
        brand: "kohler",
      },
    ]

    addToCartHelper(data, "", (isFailed, res) => {
      if (!isFailed && res) {
        setCartToast(true)
        setLoaded(false)
        const serviceVS = JSON.parse(localStorage.getItem("serviceVS"))
        if (serviceVS) {
          const datavs =
            JSON.parse(localStorage.getItem("servicePartsVs")) || []
          datavs.push(productInfo?.productId)
          sessionStorage.setItem("servicePartsVs", JSON.stringify(datavs))
        }

        partsAddToCartEvent(analytics, productInfo)
        setTimeout(() => {
          setCartToast(false)
        }, 3000)
      }
    })
  }

  const getInventoryBySku = async sku => {
    if (!kohlerCanadaFlag) {
      const { inventories = [] } = await getProductInventory(sku)
      return inventories.length ? inventories[0]?.availableQuantity : 0
    }
  }

  if (popupWidth) {
    if (showProduct && loading === "loading") {
      return (
        <LoadingPopupection
          setModal={setModal}
          device={device}
          popupWidth={popupWidth}
          fullscreen={fullscreen}
        />
      )
    }

    const skuValreplace = item?.replaceRootSku ?? item?.Cod

    const replacePartItems = selectedFile?.replacementParts[skuValreplace]

    return (
      <div
        className="popup-default"
        style={
          popupWidth && !device.isSmallScreen
            ? {
                width: popupWidth?.sidebarWidth + "px",
                top: !fullscreen ? popupWidth.headHeight : 0 + "px",
              }
            : {}
        }
      >
        <div className="popup-wrapper">
          <Container fluid>
            <div className="flex-column content-dialogs">
              <div className="header-fixed">
                <div className="d-flex justify-content-start">
                  <button
                    className="btn closebtns"
                    onClick={() => {
                      setModal(false)
                    }}
                    data-testid="parts-modal-close"
                  >
                    {device?.isLargeScreen || device.isExtraLargeScreen ? (
                      <CloseIcon />
                    ) : (
                      <DownIcon />
                    )}
                  </button>
                </div>
              </div>

              <div className="main-image mt-0">
                {loading === "loading" ? (
                  <LoaderSpinner />
                ) : (
                  <img
                    src={
                      isValidImg ? item?.currentVarent?.imgUrl : comingSoon?.src
                    }
                    alt="comming soon"
                  />
                )}
              </div>
              <div className="text-container">
                <div className="flag-container">
                  {item?.currentVarent?.details?.discontinued ? (
                    <p className={`fs-13 fw-600 tag-discontinue discontinued`}>
                      {discontinuedText}
                    </p>
                  ) : null}

                  {!kohlerCanadaFlag &&
                  (item?.currentVarent?.details?.isStock === "false" ||
                    inventory === 0) &&
                  item?.currentVarent?.details?.discontinued === false ? (
                    <p className={`fs-13 fw-600 tag-discontinue outof-stoke`}>
                      {outOfStockText}
                    </p>
                  ) : null}
                </div>

                <Heading
                  level={2}
                  className="label-name fs-28 fw-325 text-capitalize"
                >
                  {item?.data?.productName_s ||
                    item?.Name?.toLowerCase() ||
                    "N/A"}
                </Heading>
                <p className="varient-text fs-14 fw-500">
                  {item?.currentVarent?.value || "N/A"}
                  {item?.replaceRootSku
                    ? ` (${replacesText} ${item?.replaceRootSku})`
                    : null}
                </p>
                {item?.currentVarent?.price !== "NaN" ? (
                  <>
                    {item?.currentVarent?.discountedPrice ? (
                      <Heading
                        level={2}
                        className="price-text fs-28 fw-325 text-capitalize "
                      >
                        {item?.currentVarent?.currencySign}
                        {item?.currentVarent?.discountedPrice}
                      </Heading>
                    ) : null}
                    <p
                      className={`price-text fs-16 fw-400 text-capitalize ${
                        item?.currentVarent?.discountedPrice
                          ? "discount-price"
                          : ""
                      }`}
                    >
                      {item?.currentVarent?.currencySign}
                      {item?.currentVarent?.price}
                    </p>

                    <p className="pricelist-text fs-16 fw-400 product-description mb-2">
                      {item?.currentVarent?.currencySign}
                      {item?.currentVarent?.pricelist}{" "}
                      <span className="list-text">
                        <span> {listPriceText}</span>

                        <span className="list-description">
                          {listPriceDescText}
                        </span>
                      </span>
                    </p>
                  </>
                ) : null}
                <p className="fs-16 fw-300 text-color">
                  <span className="fw-400">{colorFinish}: </span>
                  {item?.currentVarent?.label || "N/A"}
                </p>
                <SwatchItems
                  variantList={variantList}
                  setVariant={setVariant}
                  variant={variant}
                />

                {!kohlerCanadaFlag && (
                  <>
                    <div className="d-flex align-items-center justify-content-center detailpop-up">
                      {showStockDiscontinue != null ? (
                        <button
                          className="fw-400 stock-button mt-5"
                          disabled={true}
                        >
                          {showStockDiscontinue}
                        </button>
                      ) : (
                        <div className="button-carts d-flex flex-row justify-content-center align-items-end mt-3">
                          <div
                            className={`d-flex flex-column processing-div ${
                              loaded ? "processing" : ""
                            }`}
                          >
                            {inventoryWarn ? (
                              <div className="inventory-warning">
                                <WarnIcon /> {inventoryTextVal(inventory)}
                              </div>
                            ) : (
                              ""
                            )}
                            {!item?.currentVarent?.details?.discontinued &&
                            loading === "success" &&
                            inventory ? (
                              <div className="addtocart-widgets d-flex">
                                <div className="counter-widgets d-flex">
                                  <button
                                    className="decrement-widgets"
                                    onClick={decrementCounter}
                                  >
                                    <DecIcon />
                                  </button>
                                  <input
                                    type="number"
                                    onChange={e =>
                                      handlerCounter(e?.target?.value)
                                    }
                                    value={counter}
                                  />
                                  <button
                                    className="increment-widgets"
                                    onClick={incrementCounter}
                                  >
                                    <IncIcon />
                                  </button>
                                </div>
                                <div className="button-carts">
                                  <button
                                    onClick={() =>
                                      !loaded
                                        ? handlerCart({
                                            ...item,
                                            fileTitle: title,
                                            quantity: counter,
                                            pdpDetails,
                                          })
                                        : null
                                    }
                                    disabled={loaded}
                                    type="button"
                                    className={`fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ${
                                      loaded ? "disabled" : ""
                                    }
                        `}
                                  >
                                    {loaded ? <LoadingIcon /> : addToCart}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {(item?.currentVarent?.details?.isStock ===
                              "false" ||
                              inventory === 0) &&
                            !item?.currentVarent?.details?.discontinued ? (
                              <NotifyItems item={item} />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {replaceId && replacePartItems && replaceId !== productId ? (
                  <ReplacementParts
                    productNumber={productNumber}
                    setProductNumber={setProductNumber}
                    variant={variant}
                    productId={productId}
                    partController={partController}
                    replaceRootSku={item}
                    selectedFile={selectedFile}
                  />
                ) : null}
              </div>
            </div>
          </Container>
        </div>
        {cartToast ? (
          <div className="cart-toast-text">
            <p>
              ( {counter} ) {counter > 1 ? "Items" : "Item"} has been added to
              your cart.
            </p>
            <button onClick={() => setCartToast(false)}>
              <CartCloseIcon />
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }
}

DetailPopUp.propTypes = {
  productId: PropTypes.string.isRequired,
  setModal: PropTypes.func.isRequired,
  analytics: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  fullscreen: PropTypes.bool.isRequired,
  setWidthSize: PropTypes.func.isRequired,
  partController: PropTypes.shape({
    actions: PropTypes.shape({
      get: PropTypes.shape({
        entryByKey: PropTypes.func.isRequired,
      }),
    }),
  }),
}

export default DetailPopUp
